import { render, staticRenderFns } from "./ExemptionList.vue?vue&type=template&id=3b8a61c1&"
import script from "./ExemptionList.vue?vue&type=script&lang=js&"
export * from "./ExemptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports